import { render, staticRenderFns } from "./SendMeal2Report.vue?vue&type=template&id=52a6d221&scoped=true&"
import script from "./SendMeal2Report.vue?vue&type=script&lang=js&"
export * from "./SendMeal2Report.vue?vue&type=script&lang=js&"
import style0 from "./SendMeal2Report.vue?vue&type=style&index=0&id=52a6d221&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a6d221",
  null
  
)

export default component.exports